import React from 'react';
import './HomePage.css';
import Splash from './Splash';

function RenderHomePage(){
   
    return (
        <div className='home-wrapper'>
                <Splash />
        </div>
    );
}

export default RenderHomePage;